const BASE_URL = process.env.REACT_APP_API_URL_DEFAULT;

export const USER_URL = {
  GetUserManagement: `${BASE_URL}usermanagement/GetAllUsers`,
  UpdateUser: `${BASE_URL}usermanagement/UpdateUser`,
  RemoveUser: `${BASE_URL}usermanagement/RemoveUser`,
};

export const MASTERDATA_URL = {
  GetAllRoles: `${BASE_URL}masterdata/GetAllRoles`,
  GetAllSuperRegions: `${BASE_URL}masterdata/GetAllSuperRegions`,
  GetAllRegions: `${BASE_URL}masterdata/GetAllRegions`,
  GetAllCountries: `${BASE_URL}masterdata/GetAllCountries`,
};

export const FETCH_AD_USERS = "https://graph.microsoft.com/v1.0/users";
